var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "noImprimir" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-app-bar",
                { staticClass: "appbarPrint", attrs: { absolute: "" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(" Entrega y Recepción de Cintas ")
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-5",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.print()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("mdi-printer")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "appbarSpace" },
        [
          _c("v-col", { attrs: { cols: "12" } }, [
            _c("table", [
              _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "centerItem p25 b-white text-left py-3" },
                    [
                      _c("v-img", {
                        staticClass: "logo",
                        attrs: {
                          src: require("../../../assets/tecnologicagente.jpg"),
                          alt: "Logo Daycohost"
                        }
                      })
                    ],
                    1
                  ),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("h2", [
                      _c("b", [_vm._v("ENTREGA Y RECEPCIÓN DE CINTAS")])
                    ])
                  ]),
                  _c("td", { staticClass: "p25 b-white" })
                ])
              ])
            ]),
            _c("table", { staticClass: "my-5" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { staticClass: "p15 text-center py-3" }, [
                    _c("div", [_c("b", [_vm._v("FECHA")])])
                  ]),
                  _c("td", { staticClass: "text-center p15" }, [
                    _c("div", [_c("b", [_vm._v("HORA")])])
                  ]),
                  _c("td", { staticClass: "p50 text-center" }, [
                    _c("div", [_c("b", [_vm._v("CLIENTE")])])
                  ]),
                  _c("td", { staticClass: "text-center p20" }, [
                    _c("div", [_c("b", [_vm._v("TICKET")])])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "p15 text-center py-3" }, [
                    _c("div", [_vm._v(_vm._s(_vm.date))])
                  ]),
                  _c("td", { staticClass: "text-center p15" }, [
                    _c("div", [_vm._v(_vm._s(_vm.hour))])
                  ]),
                  _c("td", { staticClass: "p50 text-center" }, [
                    _c("div", [_vm._v(_vm._s(_vm.customerName))])
                  ]),
                  _c("td", { staticClass: "text-center p20" }, [
                    _c("div", [_vm._v(_vm._s(_vm.ticketCode))])
                  ])
                ])
              ])
            ]),
            _c("table", { staticClass: "my-5" }, [
              _c(
                "tbody",
                [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "p20 text-center py-1",
                        attrs: { rowspan: "1", colspan: "2" }
                      },
                      [_c("div", [_c("b", [_vm._v("DAYCOHOST")])])]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "text-center p80",
                        attrs: { rowspan: "2" }
                      },
                      [_c("div", [_c("b", [_vm._v("CÓDIGO(S) DE CINTA(S)")])])]
                    )
                  ]),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "p10 text-center py-1",
                        attrs: { rowspan: "1", colspan: "1" }
                      },
                      [_c("div", [_c("b", [_vm._v("ENTREGA")])])]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "p10 text-center",
                        attrs: { rowspan: "1", colspan: "1" }
                      },
                      [_c("div", [_c("b", [_vm._v("RECIBE")])])]
                    )
                  ]),
                  _vm._l(_vm.tapes, function(tape, key) {
                    return _c("tr", { key: key }, [
                      _c(
                        "td",
                        { staticClass: "text-center p10" },
                        [
                          tape.isDelivered
                            ? _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-check")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "td",
                        { staticClass: "text-center p10" },
                        [
                          tape.isReceived
                            ? _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-check")
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("td", { staticClass: "text-center py-3" }, [
                        _c("div", [_vm._v(_vm._s(tape.code))])
                      ])
                    ])
                  })
                ],
                2
              )
            ]),
            _c("table", { staticClass: "my-5" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white py-2" }, [
                    _c("div", [
                      _c("b", [_vm._v("PERSONAL AUTORIZADO POR DAYCOHOST")])
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white py-2" }, [
                    _c("div", [
                      _c("b", [_vm._v("PERSONAL AUTORIZADO POR CLIENTE")])
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", { staticClass: "fs-14" }, [
                      _vm._v(_vm._s(_vm.employeeName))
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c("div", { staticClass: "fs-14" }, [
                        _vm._v(
                          _vm._s(_vm.contactName) +
                            " " +
                            _vm._s(_vm.contactLastName)
                        )
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("CI")]),
                        _vm._v(": " + _vm._s(_vm.contactCI))
                      ])
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p50 mx-auto mt-10" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA Y SELLO ")
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p50 mx-auto mt-12" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }